module.exports = __webpack_public_path__ + "img/outterEngraving@2x.6db23ce.jpg";